module.exports = __webpack_public_path__ + "media/images/woman-in-the-1st-place-813f5d7aae0c830c4c91d83ad16dd9c3.png";